import { Field, Float, ID, InputType, ObjectType } from 'type-graphql'
import { modelOptions, Prop } from '@typegoose/typegoose'
import { BaseEntity } from '../base/BaseEntity'
import { generateEntityId } from '../generateEntityId'
import { UnitOfMeasureCategoryEnum } from './UnitOfMeasureCategoryEnum'

@ObjectType()
@InputType('UnitOfMeasureInput')
@modelOptions({ schemaOptions: { timestamps: true } })
export class UnitOfMeasure extends BaseEntity {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: () => generateEntityId('uom') })
  declare _id: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  symbol?: string

  @Field(() => UnitOfMeasureCategoryEnum, { nullable: true })
  @Prop({ type: String, enum: UnitOfMeasureCategoryEnum })
  category?: UnitOfMeasureCategoryEnum

  @Field(() => Float, { nullable: true })
  @Prop({ type: Number })
  conversionFactor?: number
}
